export default "__VITE_ASSET__oIVEKxlo__"